import React from 'react'

import { HiOutlineExclamation } from 'react-icons/hi'

import { Box, Circle } from '@chakra-ui/react'
import { motion } from 'framer-motion'

import {
  GLOBAL_MAP_CIRCULAR_MENU_ITEM_CLICK,
  trackEvent,
} from '@/utils/analytics'

import { FacilityPointIProps } from '../../mapbox/types/types'
import { MENU_ITEM_SIZE } from '../constants'

interface CircularMenuItemIProps {
  clusterFacilityCount: number
  facility: FacilityPointIProps
  position: { x: number; y: number }
  onClose: () => void
  onFacilityClick: (facilityId: string) => void
}

export const CircularMenuItem: React.FC<CircularMenuItemIProps> = ({
  clusterFacilityCount,
  facility,
  position,
  onClose,
  onFacilityClick,
}) => {
  const hasIncidents = facility.incidentCount > 0
  const numCount = facility.incidentCount > 999 ? '1k+' : facility.incidentCount

  const handleFacilityClick = () => {
    trackEvent(GLOBAL_MAP_CIRCULAR_MENU_ITEM_CLICK, {
      facility_id: facility.id,
      floor_id: facility.floorId,
      facility_count: clusterFacilityCount,
    })
    if (facility.floorId) {
      onFacilityClick(facility.floorId)
    }
    onClose()
  }

  return (
    <motion.div
      animate={{
        x: position.x,
        y: position.y,
        scale: 1,
      }}
      exit={{ scale: 0 }}
      initial={{ scale: 0 }}
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        transform: 'translate(-50%, -50%)',
        cursor: 'pointer',
        zIndex: 2,
      }}
      transition={{
        type: 'spring',
        stiffness: 200,
        damping: 20,
      }}
    >
      <Circle
        _after={{
          content: '""',
          pos: 'absolute',
          borderRadius: '50%',
          h: '57px',
          w: '57px',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          borderColor: hasIncidents ? '#fff' : '#4ad06c',
          borderWidth: '2px',
          borderStyle: 'solid',
        }}
        bg={hasIncidents ? '#D01030' : '#fff'}
        boxShadow={
          hasIncidents
            ? '0 2px 7px 0 rgba(189,25,25,0.5)'
            : '4px 0 14px 0 rgba(65,71,95,0.17)'
        }
        onClick={handleFacilityClick}
        pos='relative'
        size={`${MENU_ITEM_SIZE}px`}
      >
        <Box
          color={hasIncidents ? '#fff' : '#000'}
          fontSize='16px'
          fontWeight='semibold'
          letterSpacing='-0.4px'
        >
          {facility.shortName}
        </Box>

        {hasIncidents && (
          <>
            <Circle
              bg='#fff'
              bottom='-6px'
              boxShadow='0 2px 7px 0 rgba(189,25,25,0.5)'
              left='-8px'
              pos='absolute'
              size='28px'
              zIndex='overlay'
            >
              <HiOutlineExclamation color='#D01030' size={16} />
            </Circle>

            <Circle
              bg='#fff'
              bottom='-6px'
              boxShadow='0 2px 7px 0 rgba(189,25,25,0.5)'
              pos='absolute'
              right='-8px'
              size='28px'
              zIndex='overlay'
            >
              <Box
                color='#D01030'
                fontSize='14px'
                fontWeight='bold'
                letterSpacing='-0.4px'
              >
                {numCount}
              </Box>
            </Circle>
          </>
        )}
      </Circle>
    </motion.div>
  )
}
